export default __webpack_public_path__ + "static/media/IF_MySalesStyle_Small.fcd7ef9c.jpg";